import React, { useState } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import Editor from "../../../../components/elements/tiptap-editor/Editor";
import Button from "../../../../components/form/Button";
import FileUploadSingle from "../../../../components/form/FileUploadSingle";
import UrlInput from "../../../../components/form/UrlInput";

const EditorPage = () => {
  const [nodes, setNodes] = useState([
    { id: "1", type: "text", value: "" },
    { id: "2", type: "image", value: "" },
    { id: "3", type: "video", value: "" },
  ]);

  const handleDragEnd = (result) => {
    if (!result.destination) return;

    const reordered = Array.from(nodes);
    const [movedItem] = reordered.splice(result.source.index, 1);
    reordered.splice(result.destination.index, 0, movedItem);
    setNodes(reordered);
  };

  const addNode = (type) => {
    setNodes((prev) => [
      ...prev,
      {
        id: Date.now().toString(),
        type,
        value: "",
      },
    ]);
  };

  return (
    <div className="space-y-5">
      <DragDropContext onDragEnd={handleDragEnd}>
        <Droppable droppableId="droppable-nodes">
          {(provided) => (
            <div
              className="space-y-3 bg-white rounded-md p-5"
              ref={provided.innerRef}
              {...provided.droppableProps}
            >
              {nodes.map((node, i) => (
                <Draggable key={node.id} draggableId={node.id} index={i}>
                  {(provided) => (
                    <div
                      className="flex items-center gap-3 group"
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                    >
                      <div
                        {...provided.dragHandleProps}
                        className="opacity-0 group-hover:opacity-100"
                      >
                        <i className="fa-fw fa-solid fa-grip-dots-vertical cursor-move"></i>
                      </div>
                      {node?.type === "text" && <Editor height={200} />}
                      {node?.type === "image" && (
                        <FileUploadSingle
                          accept={"jpg,png,jpeg"}
                          placeholder={
                            "Drag your photos here to start uploading"
                          }
                        />
                      )}
                      {node?.type === "video" && (
                        <UrlInput placeholder="Input your video link here" />
                      )}
                      <button
                        type="button"
                        className="w-8 h-8 group-hover:opacity-100 flex items-center justify-center text-red-500 hover:!opacity-65 transition-opacity duration-300 opacity-0"
                        onClick={() =>
                          setNodes((pre) =>
                            pre?.filter((item, index) => item?.id !== node?.id)
                          )
                        }
                      >
                        <i className="fa-fw fa-regular fa-trash-can"></i>
                      </button>
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>

      <div className="flex items-center justify-around">
        <Button
          buttonIcon={"fa-regular fa-file-lines"}
          buttonLabel="Add Text"
          buttonFunction={() => addNode("text")}
        />
        <Button
          buttonIcon={"fa-regular fa-image"}
          buttonLabel="Add Image"
          buttonFunction={() => addNode("image")}
        />
        <Button
          buttonIcon={"fa-regular fa-video"}
          buttonLabel="Add Video"
          buttonFunction={() => addNode("video")}
        />
      </div>
    </div>
  );
};

export default EditorPage;
